import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e18abba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi_buttons" }

import IconButton from '@/components/molecules/IconButton.vue'
import { computed, withDefaults } from 'vue'

type PropsType = {
  selectTabName?: string
  options?: { [key: string]: any }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiButtons',
  props: {
    selectTabName: null,
    options: { default: () => [] }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { selectTabName?: string, options: { [key: string]: any }[] };



const tabLength = computed<number>(() => props.options.length - 1)

const klass = computed(() => {
  return (index: number) => {
    let k = 'center'

    switch (index) {
      case 0:
        k = 'first'
        break
      case tabLength.value:
        k = 'last'
        break
    }
    return k
  }
})

const iconColor = computed(() => {
  return (tabName: string) => {
    return props.selectTabName === tabName ? 'color-white' : 'color-dark2'
  }
})

const bgColor = computed(() => {
  return (tabName: string) => {
    return props.selectTabName === tabName ? 'primary' : 'white'
  }
})



const select = (tabName: string) => {
  emit('select', tabName)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass([_unref(klass)(index), option.className])
        }, [
          _createVNode(IconButton, {
            icon: option.icon,
            useBorder: true,
            iconColor: _unref(iconColor)(option.tabName),
            bgColor: _unref(bgColor)(option.tabName),
            toolTipText: option.text,
            onClick: ($event: any) => (select(option.tabName)),
            "data-test": 'icon-button-' + option.tabName
          }, null, 8, ["icon", "iconColor", "bgColor", "toolTipText", "onClick", "data-test"])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})